import { useCallback, useContext, useMemo } from 'react'

import { Text } from '@hhgtech/hhg-components/mantine'
import { AspectRatio, Box, BoxProps } from '@mantine/core'
import { uuid4 } from '@sentry/utils'
import Cookies from 'js-cookie'
import { useIntl } from 'react-intl'

import { AIChatBotContext } from 'components/molecules/aiChatbot/context'
import { useCurrentUrl } from 'hooks/useCurrentUrl'
import { useIsMobile } from 'hooks/useIsMobile'

import useStyles from './index.styles'
import { AvatarFocus } from '../../avatarFocus'
import { ChatBody } from '../../chatBody'
import { MessageInput } from '../../messageInput'
import { MessageProps } from '../../messageList'
import { SuggestMessage } from '../suggestMessage'

type Props = { onStart: (message: MessageProps) => void } & BoxProps

export const StarterBox = ({
  styles,
  classNames,
  onStart,
  ...boxProps
}: Props) => {
  const { formatMessage: f } = useIntl()
  const isMobile = useIsMobile()
  const currentUrl = useCurrentUrl()
  const {
    cookieId,
    setChatId,
    allowSaveHistory,
    starterAvatarSize,
    expandWidget,
  } = useContext(AIChatBotContext)
  const { classes } = useStyles(
    { starterAvatarSize: starterAvatarSize || 183 },
    {
      name: 'AIChatBotWidget__StarterBox',
      styles,
      classNames,
    },
  )
  const suggestList = useMemo(
    () => [
      {
        title: 'Ciri-ciri Si Kecil Tidak Cocok Susu Sapi',
        description: '',
      },
      {
        title: 'Tips untuk Si Kecil Tidak Cocok Susu Sapi Tumbuh Optimal',
        description: '',
      },
    ],
    [],
  )

  const handleStartChat = useCallback((message: string) => {
    if (!message) return
    const newChatId = uuid4()
    setChatId(newChatId)
    allowSaveHistory && cookieId && Cookies.set(cookieId, newChatId)
    onStart?.({
      message,
      type: 'current',
      date: new Date(),
    })
  }, [])

  return (
    <ChatBody
      classNames={{
        action: classes.action,
        scrollBody: classes.scrollBody,
      }}
      action={
        <MessageInput onSubmit={({ message }) => handleStartChat(message)} />
      }
      {...boxProps}
    >
      <Box className={classes.root}>
        {expandWidget && (
          <Box className={classes.mainInfo}>
            <Box className={classes.header}>
              <Box className={classes.avatarWrapper}>
                <AspectRatio ratio={183 / 160}>
                  <Box>
                    <Box className={classes.frame}></Box>
                    <AvatarFocus
                      borderSize={0}
                      avatarSize={isMobile ? 122 : 140}
                      maxWidthPercent={65}
                      classNames={{
                        root: classes.avatar,
                        avatarRoot: classes.avatarRoot,
                      }}
                    />
                  </Box>
                </AspectRatio>
              </Box>
              <Text size="s1" className={classes.welcomeText}>
                {/* {f({
                id: 'chatbot.welcomeMess',
                defaultMessage: 'Hi 👋, how can I assist you today?',
              })} */}
                Halo Ayah/Bunda!
                <br />
                Bagaimana Hello Sehat Expert bisa membantu hari ini?
              </Text>
            </Box>
          </Box>
        )}
        <Box className={classes.suggestListing}>
          <Text size="p4" className={classes.suggestContent}>
            {f({
              id: 'chatbot.suggestIntro',
              defaultMessage:
                'Typing in a message or choose one of the options below:',
            })}
          </Text>
          {suggestList.map((i, idx) => (
            <SuggestMessage
              key={String(idx)}
              heading={i.title}
              description={i.description}
              data-event-category="Chatbot"
              data-event-action={`Click - ${i.title}`}
              data-event-label={currentUrl}
              onClick={() => handleStartChat(i.title)}
            />
          ))}
        </Box>
      </Box>
    </ChatBody>
  )
}
